export default "__VITE_ASSET__C5wOSvK9__"